module.exports = __webpack_public_path__ + "static/img/bg-banner-home.ff85689.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bg-banner-home.png
// module id = /L/9
// module chunks = 1